

export class TImportadorItemResultsViewModel {

    constructor() {

    }


}

export class FilterTNTOperatorViewModel
{
    public IdPais: number;
    public Nombre: string;
}

export class TcTNTPaisViewModel {
    
    public Id: number;
    public ConvenioIsoTraces: string;
    public Descripcion: string;
}



